/**
 * RA Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyDTO } from './companyDTO';
import { CompetencyCondition } from './competencyCondition';


export interface SmartSearchRequestDTO { 
    conditions?: Array<CompetencyCondition>;
    companies?: Array<CompanyDTO>;
    seniorityList?: Array<SmartSearchRequestDTO.SeniorityListEnum>;
}
export namespace SmartSearchRequestDTO {
    export type SeniorityListEnum = 'JUNIOR' | 'JUNIOR_MEDIOR' | 'MEDIOR' | 'MEDIOR_SENIOR' | 'SENIOR';
    export const SeniorityListEnum = {
        Junior: 'JUNIOR' as SeniorityListEnum,
        JuniorMedior: 'JUNIOR_MEDIOR' as SeniorityListEnum,
        Medior: 'MEDIOR' as SeniorityListEnum,
        MediorSenior: 'MEDIOR_SENIOR' as SeniorityListEnum,
        Senior: 'SENIOR' as SeniorityListEnum
    };
}


